import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { IComCdItemState, IDeptCdItemState, IPjt0102MState, IPjtInfoItemState, IUserItemState } from '../../models/pjt/pjt0102m_model';
  
const initialState: IPjt0102MState = {
    userList : [],      // 사용자목록
    deptCdList : [],    // 부서콤보
    cmbDeptUsrList: [], // 프로젝트관리부서
    cmbOfcUsrList: [],  // 프로젝트관리실

    cmbList021: [],             // 개발유형 코드
    cmbList022: [],             // 사업구분 코드
    cmbList023: [],             // 프로젝트 성격 코드

    cmbList024: [],             // 프로젝트 관리부서 -> 프로젝트 부서 선택전 : 전체유저, 프로젝트 부서 선택 후 : 부서 팀원
    cmbList025: [],             // 프로젝트 관리실장 -> 프로젝트 관리실 선택전 : 전체유저, 프로젝트 관리실 선택 후 : 관리실 팀원

    pjtInfoItem: {
        id: 0,
        pmEmpNo: '', //pm사원번호
        pmUserNm: '', //pm사원명
        pjCtrStdt: '',    // 계획시작일자
        pjCtrEndt: '',    // 계획종료일자
        pjStartDt: '',    // 수행시작일자
        pjEndDt: '',    // 수행종료일자
        pjCd: '',// 프로젝트코드
        pjNm: '',// 프로젝트명
        pjCntnt: '',// 프로젝트내용
        companyInstCd: '',//업체기관코드
        companyId:'',//업체ID
        cusNm: '',// 고객사명
        workDcd: '',// 사업구분코드(공통코드 022)
        pjMainNm: '',// 주사업자명
        pjDevTypeCd: '',// 개발유형코드(공통코드 021)
        pjTypeCd: '',// 프로젝트성격코드(공통코드 023)
        pjReg: '',// 프로젝트지역
        remoteYn: '',// 원격지여부
        pmUserId: '',// PM 회원ID
        pjAmnDeptCd: '',// 프로젝트관리부서
        pjAmnDeptNm: '',// 프로젝트관리부서명
        pjAmnDeptEmpNo: '',// 프로젝트관리부서장
        pjAmnDeptUserNm: '',//프로젝트관리부서장명
        pjAmnOfcDeptCd: '',// 프로젝트관리실
        pjAmnOfcDeptNm: '',// 프로젝트관리실명
        pjAmnOfcEmpNo: '',// 프로젝트관리실장
        pjAmnOfcUserNm: '',// 프로젝트관리실장명
        ctrManMonth: 0,// 계약공수
        totAmntAmt: 0,// 총계약금액 (부가세제외)
        pjConsAmt: 0,// 컨설팅비용
        pjDevAmt: 0,// 개발비용
        pjHwAmt: 0,// H/W비용
        pjSwAmt: 0,// S/W비용
        pjEtcAmt: 0,// 기타비용
        prcsManMonth: 0,// 수행공수
        expctOpenDt: '',  // 오픈(예정)일자
        endYn: 'N',// 종료여부
        delYn: '',// 삭제여부
        pjDevformType: '',// 프로젝트 개발형식
        pjDevtoolView: '',// 프로젝트 개발툴 (화면)
        pjDevtoolSvc: '',// 프로젝트 개발툴 (서비스)
        pjDevtoolRpt: '',// 프로젝트 개발툴 (레포트)
        pjDevtoolDb: '',// 프로젝트 개발툴 (DB)
        rgstEmpNo: '',// 등록사원번호
    },                  // 프로젝트정보
}

export const pjt0102m_Slice = createSlice({
    name: "pjt0102m_Slice",
    initialState: initialState,
    reducers: {
        initState: (state) => {
            Object.assign(state, {...initialState,
                                  userList : state.userList,
                                  cmbDeptUsrList : state.cmbDeptUsrList,
                                  cmbOfcUsrList : state.cmbOfcUsrList,
                                  cmbList021 : state.cmbList021,
                                  cmbList022 : state.cmbList022,
                                  cmbList023 : state.cmbList023,
                                  cmbList024 : state.cmbList024,
                                  cmbList025 : state.cmbList025,
                                 });
        },
        setUserList: (state, action:PayloadAction<IUserItemState[]>) => {
            state.userList = action.payload;
        },
        setDeptUsrList: (state, action:PayloadAction<IDeptCdItemState[]>) => {
            state.deptCdList = action.payload;
        },
        setCmbDeptUsrList: (state, action:PayloadAction<IDeptCdItemState[]>) => {
            state.cmbDeptUsrList = action.payload;
        },
        setCmbOfcUsrList: (state, action:PayloadAction<IDeptCdItemState[]>) => {
            state.cmbOfcUsrList = action.payload;
        },
        setCmbList021: (state, action:PayloadAction<IComCdItemState[]>) => {
            state.cmbList021 = action.payload;
        },
        setCmbList022: (state, action:PayloadAction<IComCdItemState[]>) => {
            state.cmbList022 = action.payload;
        },
        setCmbList023: (state, action:PayloadAction<IComCdItemState[]>) => {
            state.cmbList023 = action.payload;
        },
        setCmbList024: (state, action:PayloadAction<IComCdItemState[]>) => {
            state.cmbList024 = action.payload;
        },
        setCmbList025: (state, action:PayloadAction<IComCdItemState[]>) => {
            state.cmbList025 = action.payload;
        },
        setPjtInfoItem: (state, action:PayloadAction<IPjtInfoItemState>) => {
            state.pjtInfoItem = action.payload;
        },
    },
});

export default pjt0102m_Slice.reducer;
export const Pjt0102mAction  = pjt0102m_Slice.actions;
export const Pjt0102mReducer = pjt0102m_Slice.reducer;